import type { DatasetType } from '@/views/calculations/type/resultView.type'

export const computeMaxTotal = (datasets: DatasetType[], trajectoryCount: number) => {
  if (!datasets.length || !trajectoryCount) {
    return 0
  }

  const visibleDatasets = datasets.filter((dataset) => !dataset.isTotal)

  if (!visibleDatasets.length) {
    return 0
  }

  let maxTotal = 0

  for (let index = 0; index < trajectoryCount; index += 1) {
    const stackTotal = visibleDatasets.reduce((sum, dataset) => {
      return sum + Number(dataset.data[index] ?? 0)
    }, 0)

    maxTotal = Math.max(maxTotal, stackTotal)
  }

  return maxTotal
}

export const computeMaxColumnValue = (datasets: DatasetType[], trajectoryCount: number) => {
  const visible = datasets.filter((dataset) => !dataset.isTotal)
  let max = 0

  for (let index = 0; index < trajectoryCount; index += 1) {
    for (const dataset of visible) {
      max = Math.max(max, Number(dataset.data[index] ?? 0))
    }
  }

  return max
}

export const getStackBreakdown = (datasets: DatasetType[], dataIndex: number) => {
  return datasets.reduce(
    (breakdown, dataset) => {
      if (dataset.isTotal) {
        return breakdown
      }

      const value = Number(dataset.data[dataIndex] ?? 0)
      if (value >= 0) {
        breakdown.positive += value
      } else {
        breakdown.negative += value
      }
      breakdown.net += value

      return breakdown
    },
    { positive: 0, negative: 0, net: 0 }
  )
}
